import { types as t, Instance } from 'mobx-state-tree';
import Syncable from '~/mst/models/abstract/syncable';

const CalibrationMeasurementModel = t
  .compose(
    t.model({
      serial: t.identifier,
      calibrated: t.boolean,
      name: t.string,
      // `timestamp` is when the calibration was applied (newest-attempt-wins record).
      // Pre-deploy records carry the old meaning (end of the sampled window); the two
      // agree to within the gap between a window closing and the batch running.
      timestamp: t.maybeNull(t.number),
      // The fit window. Null on a record that never reached the fit, and absent on
      // every pre-deploy record — always read defensively.
      from_ts: t.maybeNull(t.number),
      to_ts: t.maybeNull(t.number),
      metrics: t.frozen(),
      params: t.frozen(),
      reference: t.frozen(),
      // Materialized gate inputs. Present only on records written after the backend
      // deploy — treat every one as optional and degrade when absent.
      required_metrics: t.maybeNull(t.frozen()),
      samples: t.maybeNull(t.frozen()),
      reference_samples: t.maybeNull(t.frozen())
    }),
    Syncable
  )
  .named('CalibrationMeasurement');

export interface ICalibrationMeasurementModel extends Instance<typeof CalibrationMeasurementModel> {}

export default CalibrationMeasurementModel;
